import { render, staticRenderFns } from "./RcvScLPrice.vue?vue&type=template&id=002368da"
import script from "./RcvScLPrice.vue?vue&type=script&lang=js"
export * from "./RcvScLPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports